import React from 'react';

const defaultState = {
  distanceFromTop: 0,
  viewportHeight: 0,
  viewportWidth: 0,
  animationStart: 0,
  animationEnd: 0,
  animationExitStart: 0,
  animationExitEnd: 0,
  elementHeight: 0,
  elementWidth: 0,
};

const getWindowDimensions = (elRef) => {
  const {
    innerWidth: viewportWidth = 0,
    innerHeight: viewportHeight = 0,
    pageYOffset = 0,
  } = window;

  const distanceFromTop = elRef ? pageYOffset + elRef.getBoundingClientRect().top : 0;
  const elementHeight = elRef ? elRef.getBoundingClientRect().height : 0;
  const elementWidth = elRef ? elRef.getBoundingClientRect().width : 0;

  return {
    distanceFromTop,
    viewportHeight,
    viewportWidth,
    animationStart: distanceFromTop - viewportHeight,
    animationEnd: distanceFromTop - viewportHeight + elementHeight,
    animationExitStart: distanceFromTop,
    animationExitEnd: distanceFromTop + elementHeight,
    elementHeight,
    elementWidth,
  };
};

const useWindowPositioning = () => {
  const elementRef = React.useRef(null);
  const [windowDimensions, setWindowDimensions] = React.useState(defaultState);

  React.useEffect(() => {
    // TODO: Handle resize
    // const handleResize = () => {
    //   setWindowDimensions(getWindowDimensions());
    // }

    if (elementRef && elementRef.current) {
      setWindowDimensions(getWindowDimensions(elementRef.current));
    }

    // window.addEventListener('resize', handleResize);
    // return () => window.removeEventListener('resize', handleResize);
  }, [elementRef]);

  return { windowDimensions, elementRef };
};

export default useWindowPositioning;
